/* eslint-disable no-console */
import React from "react";
import { useNavigate } from "react-router-dom";
import { IPackage } from "../../../common/types";
import { ImageGallery, PackageAction, PackageInfo } from "../../molecules";
import { travelerType } from "../../../enums";
import { PackageItemWrapper } from "./PackageListFrontEnd.style";
export interface IPackageItemProps {
  travelPackage: IPackage;
  isMobile: boolean;
  partner?: string;
  selectedInterest?: string;
  discount?: number;
}

const PackageItem: React.FC<IPackageItemProps> = ({
  travelPackage,
  isMobile,
  partner,
  selectedInterest,
  discount,
}) => {
  const history = useNavigate();
  const handelSelect = () => {
    if (isMobile) {
      history(`/package/${travelPackage?.id}`);
    } else {
      const win: any = window.open(`/package/${travelPackage?.id}`, "_blank");
      win.focus();
    }
    // history.push(`/package/${travelPackage.id}`);
  };
  return (
    <PackageItemWrapper>
      <div>
        <ImageGallery
          images={travelPackage?.images || []}
          showThumbnails={false}
          showPlayButton={false}
        />
      </div>
      <div>
        <PackageInfo
          title={travelPackage?.name || ""}
          departureCity={travelPackage?.departureCity || ""}
          departureDate={travelPackage?.departureDate || ""}
          returnDate={travelPackage?.returnDate || ""}
          serviceInclude={travelPackage?.serviceInclude || []}
          categories={travelPackage?.categories || []}
          partner={partner}
          onRequest={travelPackage?.onRequest}
        />
      </div>
      <div>
        <PackageAction
          price={travelPackage?.minPricePerAdult || 0}
          currency="€"
          onSelect={handelSelect}
          interest={
            travelPackage?.travelerType?.includes(selectedInterest || "")
              ? (travelerType[selectedInterest || ""]?.label as string) || ""
              : ""
          }
          discountOffer={discount}
        />
      </div>
    </PackageItemWrapper>
  );
};

export default PackageItem;
